import { API_URL } from '../../../app-config/constants';
import type { ReleaseNotesUpdate } from '../../../types/ReleaseNotesUpdate';
import { get, put } from '../request';

const BASE = `${API_URL}/release-notes`;

getLastUpdatedReleaseNotes.operation = 'READ';
export function getLastUpdatedReleaseNotes(): Promise<ReleaseNotesUpdate> {
    return get<string>(BASE).then(lastDate => ({ id: 'lastUpdatedReleaseNotesDate', date: lastDate }));
}

updateLastUpdatedReleaseNotes.operation = 'COMMAND';
export function updateLastUpdatedReleaseNotes(): Promise<ReleaseNotesUpdate> {
    return put<string>(BASE).then(lastDate => ({ id: 'lastUpdatedReleaseNotesDate', date: lastDate }));
}
